import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';

@Injectable({
    providedIn: 'root'
})
export class CryptoService {

    keySize = 4;
    iterationCount = 1000;
    encrypted: any;

    encryptData(data:any, encryptSecretKey: string) {
        let _key = CryptoJS.enc.Utf8.parse(encryptSecretKey);
        let _iv = CryptoJS.enc.Utf8.parse(encryptSecretKey);
        let encrypted = CryptoJS.AES.encrypt(
            JSON.stringify(data), _key, {
            keySize: 16,
            iv: _iv,
            mode: CryptoJS.mode.ECB,
            padding: CryptoJS.pad.Pkcs7
        });
        this.encrypted = encrypted.toString();
        return this.encrypted;
    }
}
